module.exports = __webpack_public_path__ + "img/ic-reCAPTCHA.12beea1c.svg";